import { useEffect } from 'react';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Link } from 'foundations-components/transitional/components/Link';
import { Panel } from 'foundations-components/transitional/components/Panel';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { H5 } from 'foundations-components/transitional/components/H5';
import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import { Section } from 'foundations-components/transitional/components/Section';
import LoadingOverlayWrapper from '../../../app/components/LoadingOverlayWrapper';
import { useGetQueryParam } from '../../../app/hooks/useGetQueryParam';
import { TrackingAction, TrackingFeature, TrackingScreen, TrackingSubscreen, trackInteractionWithId, trackPageviewWithId } from '../../../app/utils/tracking';
import { getPricingUrl } from '../../../app/utils/urls';
import { useFetchProductUpdateDetails } from '../../hooks/useFetchProductUpdateDetails';
import { getPUErrorMessage } from '../utils/detailsPanelErrorMessage';
import RolloutProductUpdateDetailsPanelContent from './RolloutProductUpdateDetailsPanelContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RolloutProductUpdateDetailsPanel = ({
  handleClose
}) => {
  const rolloutIdParam = useGetQueryParam('rollout') || '';
  const updateIdParam = useGetQueryParam('update') || '';
  const {
    data: rolloutProductUpdateData,
    loading: rolloutProductUpdateLoading,
    error: rolloutProductUpdateError
  } = useFetchProductUpdateDetails(parseInt(rolloutIdParam, 10) || 0, parseInt(updateIdParam, 10) || 0);
  const rolloutProductUpdate = rolloutProductUpdateData && rolloutProductUpdateData.rolloutProductUpdate;
  const trackedTitle = rolloutProductUpdate && rolloutProductUpdate.untranslatedTitle;
  const updateId = rolloutProductUpdate && rolloutProductUpdate.id;
  useEffect(() => {
    if (!trackedTitle) {
      return;
    }
    trackPageviewWithId(TrackingScreen.PRODUCT_UPDATES, TrackingSubscreen.UPDATE_PANEL, `product update ID ${updateId}`, trackedTitle);
  }, [updateId, trackedTitle]);
  if (rolloutProductUpdateError) {
    let errorType = null;
    const networkError = rolloutProductUpdateError.networkError;
    if (networkError !== null && networkError !== void 0 && networkError.responseJSON) {
      const {
        status,
        errorType: receivedErrorType
      } = networkError.responseJSON;
      if (status === 'error' && receivedErrorType) {
        errorType = receivedErrorType;
      }
    }
    const {
      titleMessage,
      descriptionMessage,
      showUpgradeLink
    } = getPUErrorMessage(errorType);
    return /*#__PURE__*/_jsxs(Panel, {
      maxWidth: "900px",
      width: "50%",
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: handleClose
      }), /*#__PURE__*/_jsx(PanelHeader, {
        children: /*#__PURE__*/_jsx(Text, {
          as: "h2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.detailsPanel.notFoundTitle"
          })
        })
      }), /*#__PURE__*/_jsx(PanelBody, {
        children: /*#__PURE__*/_jsx(Section, {
          paddingInline: "500",
          paddingBlockStart: "400",
          children: /*#__PURE__*/_jsx(ResultsMessage, {
            illustration: "empty-state-charts",
            children: /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(H5, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: titleMessage
                })
              }), showUpgradeLink ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
                message: descriptionMessage,
                options: {
                  external: true,
                  href: getPricingUrl(),
                  onClick: () => {
                    trackInteractionWithId(TrackingScreen.PRODUCT_UPDATES, TrackingSubscreen.UPDATE_PANEL, TrackingFeature.PRICING_LINK, TrackingAction.CLICK, `product update ID ${updateId}`);
                  }
                },
                elements: {
                  Link
                }
              }) : /*#__PURE__*/_jsx(FormattedMessage, {
                message: descriptionMessage
              })]
            })
          })
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Panel, {
    "data-test-id": "details-panel",
    maxWidth: "900px",
    width: "50%",
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: handleClose
    }), /*#__PURE__*/_jsx(PanelHeader, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": "details-panel-header",
          message: "app.detailsPanel.panelTitle"
        })
      })
    }), /*#__PURE__*/_jsx(LoadingOverlayWrapper, {
      loading: rolloutProductUpdateLoading,
      children: rolloutProductUpdate && /*#__PURE__*/_jsx(RolloutProductUpdateDetailsPanelContent, {
        rolloutProductUpdate: rolloutProductUpdate
      })
    })]
  });
};
export default RolloutProductUpdateDetailsPanel;